import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const taskRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.tasks,
    name: routeNames.tasks,
    component: () => import('@/pages/tasks/TasksView.vue'),
    meta: {
      labelKey: 'tasks',
      iconText: 'assignment',
      icon: 'material-symbols-outlined',
      permission: 'tasks.read.assigned',
      featureFlag: 'tasks',
    },
  },
  {
    path: routePaths.taskDetails,
    name: routeNames.taskDetails,
    component: () => import('@/pages/tasks/TaskDetailsView.vue'),
    meta: {
      featureFlag: 'tasks',
      permission: 'tasks.read.assigned',
      rootRouteName: routeNames.tasks,
    },
  },
]
